import storage from './storage';
import events from './events';
import error from './error';

export default {
  ...storage,
  ...events,
  ...error,
};
